/////////////////////////////////////////////////////////
// Configurations related to listing.                  //
// Main configuration here is the extended data config //
/////////////////////////////////////////////////////////

// Note: The listingFields come from listingFields asset nowadays by default.
//       To use this built-in configuration, you need to change the overwrite from configHelper.js
//       (E.g. use mergeDefaultTypesAndFieldsForDebugging func)

/**
 * Configuration options for listing fields (custom extended data fields):
 * - key:                           Unique key for the extended data field.
 * - scope (optional):              Scope of the extended data can be either 'public' or 'private'.
 *                                  Default value: 'public'.
 *                                  Note: listing doesn't support 'protected' scope atm.
 * - schemaType (optional):         Schema for this extended data field.
 *                                  This is relevant when rendering components and querying listings.
 *                                  Possible values: 'enum', 'multi-enum', 'text', 'long', 'boolean'.
 * - enumOptions (optional):        Options shown for 'enum' and 'multi-enum' extended data.
 *                                  These are used to render options for inputs and filters on
 *                                  EditListingPage, ListingPage, and SearchPage.
 * - listingTypeConfig (optional):  Relationship configuration against listing types.
 *   - limitToListingTypeIds:         Indicator whether this listing field is relevant to a limited set of listing types.
 *   - listingTypeIds:                An array of listing types, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToListingTypeIds is true.
 * - categoryConfig (optional):     Relationship configuration against categories.
 *   - limitToCategoryIds:            Indicator whether this listing field is relevant to a limited set of categories.
 *   - categoryIds:                   An array of categories, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToCategoryIds is true.
 * - filterConfig:                  Filter configuration for listings query.
 *    - indexForSearch (optional):    If set as true, it is assumed that the extended data key has
 *                                    search index in place. I.e. the key can be used to filter
 *                                    listing queries (then scope needs to be 'public').
 *                                    Note: Flex CLI can be used to set search index for the key:
 *                                    https://www.sharetribe.com/docs/references/extended-data/#search-schema
 *                                    Read more about filtering listings with public data keys from API Reference:
 *                                    https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
 *                                    Default value: false,
 *   - filterType:                    Sometimes a single schemaType can be rendered with different filter components.
 *                                    For 'enum' schema, filterType can be 'SelectSingleFilter' or 'SelectMultipleFilter'
 *   - label:                         Label for the filter, if the field can be used as query filter
 *   - searchMode (optional):         Search mode for indexed data with multi-enum schema.
 *                                    Possible values: 'has_all' or 'has_any'.
 *   - group:                         SearchPageWithMap has grouped filters. Possible values: 'primary' or 'secondary'.
 * - showConfig:                    Configuration for rendering listing. (How the field should be shown.)
 *   - label:                         Label for the saved data.
 *   - isDetail                       Can be used to hide detail row (of type enum, boolean, or long) from listing page.
 *                                    Default value: true,
 * - saveConfig:                    Configuration for adding and modifying extended data fields.
 *   - label:                         Label for the input field.
 *   - placeholderMessage (optional): Default message for user input.
 *   - isRequired (optional):         Is the field required for providers to fill
 *   - requiredMessage (optional):    Message for those fields, which are mandatory.
 */

export const ageSuitability = [

  { value: '0_3_years', label: '0-3 years' },
  { value: '4_7_years', label: '4-7 years' },
  { value: '8_12_years', label: '8-12 years' },
  { value: '13_18_years', label: '13-18 years' },
];

export const Bathrooms = [

  { value: '0.5', label: '0.5' },
  { value: '1', label: '1' },
  { value: '1.5', label: '1.5' },
  { value: '2', label: '2' },
  { value: '2.5', label: '2.5' },
  { value: '3', label: '3' },
  { value: '3.5', label: '3.5' },
  { value: '4', label: '4' },
  { value: '4.5', label: '4.5' },
  { value: '5', label: '5' },
];
export const Bedrooms = [

  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
];

export const amenities = [
  { value: 'tv', label: 'TV', count: 5 },
  { value: 'wifi', label: 'Wifi', count: 5 },
  { value: 'dryer', label: 'Dryer', count: 4 },
  { value: 'hair_dryer', label: 'Hair dryer', count: 3 },
  { value: 'iron', label: 'Iron', count: 3 },
  { value: 'dishwasher', label: 'Dishwasher', count: 2 },
  { value: 'washer', label: 'Washer', count: 2 },
  { value: 'air_conditioning', label: 'Air conditioning', count: 1 },
  { value: 'coffee_maker', label: 'Coffee maker', count: 1 },
  { value: 'microwave', label: 'Microwave', count: 1 },
  { value: 'other', label: 'Other', count: 1 },
  { value: 'oven', label: 'Oven', count: 1 },
  { value: 'heating', label: 'Heating', count: 1 },
  { value: 'refrigerator', label: 'Refrigerator', count: 1 },
  { value: 'toaster', label: 'Toaster', count: 1 },

];
export const listingFields = [
  // {
  //   "scope": "public",
  //   "label": "Gears",
  //   "key": "gears",
  //   "schemaType": "long",
  //   "numberConfig": {
  //     "minimum": 1,
  //     "maximum": 24
  //   },
  //   "filterConfig": {
  //     "indexForSearch": true,
  //     "group": "primary",
  //     "label": "Gears"
  //   }
  // }
  // {
  //   key: 'bikeType',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'city-bikes', label: 'City bikes' },
  //     { option: 'electric-bikes', label: 'Electric bikes' },
  //     { option: 'mountain-bikes', label: 'Mountain bikes' },
  //     { option: 'childrens-bikes', label: "Children's bikes" },
  //   ],
  //   categoryConfig: {
  //     limitToCategoryIds: true,
  //     categoryIds: ['cats'],
  //   },
  //   filterConfig: {
  //     indexForSearch: true,
  //     filterType: 'SelectMultipleFilter', //'SelectSingleFilter',
  //     label: 'Bike type',
  //     group: 'primary',
  //   },
  //   showConfig: {
  //     label: 'Bike type',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Bike type',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a bike type.',
  //   },
  // },
  // {
  //   key: 'tire',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: '29', label: '29' },
  //     { option: '28', label: '28' },
  //     { option: '27', label: '27' },
  //     { option: '26', label: '26' },
  //     { option: '24', label: '24' },
  //     { option: '20', label: '20' },
  //     { option: '18', label: '18' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Tire size',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Tire size',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Tire size',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a tire size.',
  //   },
  // },
  // {
  //   key: 'brand',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'cube', label: 'Cube' },
  //     { option: 'diamant', label: 'Diamant' },
  //     { option: 'ghost', label: 'GHOST' },
  //     { option: 'giant', label: 'Giant' },
  //     { option: 'kalkhoff', label: 'Kalkhoff' },
  //     { option: 'kona', label: 'Kona' },
  //     { option: 'otler', label: 'Otler' },
  //     { option: 'vermont', label: 'Vermont' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Brand',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Brand',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Brand',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a brand.',
  //   },
  // },
  // {
  //   key: 'accessories',
  //   scope: 'public',
  //   schemaType: 'multi-enum',
  //   enumOptions: [
  //     { option: 'bell', label: 'Bell' },
  //     { option: 'lights', label: 'Lights' },
  //     { option: 'lock', label: 'Lock' },
  //     { option: 'mudguard', label: 'Mudguard' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Accessories',
  //     searchMode: 'has_all',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Accessories',
  //   },
  //   saveConfig: {
  //     label: 'Accessories',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: false,
  //   },
  // },
  // // An example of how to use transaction type specific custom fields and private data.
  // {
  //   key: 'note',
  //   scope: 'public',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['product-selling'],
  //   },
  //   showConfig: {
  //     label: 'Extra notes',
  //   },
  //   saveConfig: {
  //     label: 'Extra notes',
  //     placeholderMessage: 'Some public extra note about this bike...',
  //   },
  // },
  // {
  //   key: 'privatenote',
  //   scope: 'private',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['daily-booking'],
  //   },
  //   saveConfig: {
  //     label: 'Private notes',
  //     placeholderMessage: 'Some private note about this bike...',
  //   },
  // },
];

///////////////////////////////////////////////////////////////////////
// Configurations related to listing types and transaction processes //
///////////////////////////////////////////////////////////////////////

// A presets of supported listing configurations
//
// Note 1: The listingTypes come from listingTypes asset nowadays by default.
//         To use this built-in configuration, you need to change the overwrite from configHelper.js
//         (E.g. use mergeDefaultTypesAndFieldsForDebugging func)
// Note 2: transaction type is part of listing type. It defines what transaction process and units
//         are used when transaction is created against a specific listing.

/**
 * Configuration options for listing experience:
 * - listingType:         Unique string. This will be saved to listing's public data on
 *                        EditListingWizard.
 * - label                Label for the listing type. Used as microcopy for options to select
 *                        listing type in EditListingWizard.
 * - transactionType      Set of configurations how this listing type will behave when transaction is
 *                        created.
 *   - process              Transaction process.
 *                          The process must match one of the processes that this client app can handle
 *                          (check src/util/transactions/transaction.js) and the process must also exists in correct
 *                          marketplace environment.
 *   - alias                Valid alias for the aforementioned process. This will be saved to listing's
 *                          public data as transctionProcessAlias and transaction is initiated with this.
 *   - unitType             Unit type is mainly used as pricing unit. This will be saved to
 *                          transaction's protected data.
 *                          Recommendation: don't use same unit types in completely different processes
 *                          ('item' sold should not be priced the same as 'item' booked).
 * - stockType            This is relevant only to listings using default-purchase process.
 *                        If set to 'oneItem', stock management is not showed and the listing is
 *                        considered unique (stock = 1).
 *                        Possible values: 'oneItem' and 'multipleItems'.
 *                        Default: 'multipleItems'.
 * - defaultListingFields These are tied to transaction processes. Different processes have different flags.
 *                        E.g. default-inquiry can toggle price and location to true/false value to indicate,
 *                        whether price (or location) tab should be shown. If defaultListingFields.price is not
 *                        explicitly set to _false_, price will be shown.
 *                        If the location or pickup is not used, listing won't be returned with location search.
 *                        Use keyword search as main search type if location is not enforced.
 *                        The payoutDetails flag allows provider to bypass setting of payout details.
 *                        Note: customers can't order listings, if provider has not set payout details! Monitor
 *                        providers who have not set payout details and contact them to ensure that they add the details.
 */

export const listingTypes = [
  {
    listingType: 'daily-booking',
    label: 'Daily booking',
    transactionType: {
      process: 'default-booking',
      alias: 'default-booking/release-1',
      unitType: 'day',
    },
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },
  // // Here are some examples for other listingTypes
  // // TODO: SearchPage does not work well if both booking and product selling are used at the same time
  // {
  //   listingType: 'nightly-booking',
  //   label: 'Nightly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'night',
  //   },
  // },
  // {
  //   listingType: 'hourly-booking',
  //   label: 'Hourly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'hour',
  //   },
  // },
  // {
  //   listingType: 'product-selling',
  //   label: 'Sell bicycles',
  //   transactionType: {
  //     process: 'default-purchase',
  //     alias: 'default-purchase/release-1',
  //     unitType: 'item',
  //   },
  //   stockType: 'multipleItems',
  //   defaultListingFields: {
  //     shipping: true,
  //     pickup: true,
  //     payoutDetails: true,
  //   },
  // },
  // {
  //   listingType: 'inquiry',
  //   label: 'Inquiry',
  //   transactionType: {
  //     process: 'default-inquiry',
  //     alias: 'default-inquiry/release-1',
  //     unitType: 'inquiry',
  //   },
  //   defaultListingFields: {
  //     price: false,
  //     location: true,
  //   },
  // },
];

// SearchPage can enforce listing query to only those listings with valid listingType
// However, it only works if you have set 'enum' type search schema for the public data fields
//   - listingType
//
//  Similar setup could be expanded to 2 other extended data fields:
//   - transactionProcessAlias
//   - unitType
//
// Read More:
// https://www.sharetribe.com/docs/how-to/manage-search-schemas-with-flex-cli/#adding-listing-search-schemas
export const enforceValidListingType = false;

export const taxanomyIcons = [
  { id: 'airport', name: 'Airport', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779862190/Airport_noymi5.svg" },
  { id: 'barber', name: 'Barber', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780804/Barber_e1htwb.svg" },
  { id: 'brewery', name: 'Brewery', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779862418/Brewery_ito30w.svg" },
  { id: 'coffee-shop', name: 'Coffee shop', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780812/Coffee_shop_sjfhxk.svg" },
  { id: 'coworking-space', name: 'Coworking space', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779862390/extra_work_space_yadrw1.svg" },
  { id: 'dry-cleaners', name: 'Dry cleaners', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780816/Dry_cleaners_hqatxp.svg" },
  { id: 'grocery-store', name: 'Grocery store', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780822/Grocery_shop_bof4yi.svg" },
  { id: 'gym', name: 'Gym', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780823/Gym_ptuwk5.svg" },
  { id: 'restaurants', name: 'Restaurants', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780845/Restaurants_rwgtbz.svg" },
  { id: 'salon', name: 'Salon', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780847/Salon_k70wtu.svg" },
  { id: 'shopping-mall', name: 'Shopping mall', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780848/Shopping_mall_a5i9xs.svg" },
  { id: 'yoga-studio', name: 'Yoga studio', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780864/Yoga_studio_larwo8.svg" },

  { id: 'adult-dentist', name: 'Adult dentist', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780801/Adult_dentist_cxwtcy.svg" },
  { id: 'hospital', name: 'Hospital', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780825/Hospital_l5znet.svg" },
  { id: 'pediatric-dentist', name: 'Pediatric dentist', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780840/Pediatric_dentist_buek7d.svg" },
  { id: 'pediatrician', name: 'Pediatrician', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780840/Pediatrician_ij2vas.svg" },
  { id: 'pharmacy', name: 'Pharmacy', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780841/Pharmacy_etdmhf.svg" },
  { id: 'urgent-care', name: 'Urgent care', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780859/Urgent_care_pzhuej.svg" },
  { id: 'veterinarian', name: 'Veterinarian', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780861/Veterinarian_imnivi.svg" },

  { id: 'art-lessons', name: 'Art lessons', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780802/Art_lessons_hjjtm7.svg" },
  { id: 'babysitter', name: 'Babysitter', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780802/Babysitter_dxmqbh.svg" },
  { id: 'day-camps', name: 'Day camps', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780814/Day_camps_khacub.svg" },
  { id: 'daycare', name: 'Daycare', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780814/Daycare_jw20hl.svg" },
  { id: 'flexible-schools', name: 'Flexible schools', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780819/Flexible_schools_fymuyc.svg" },
  { id: 'homeschool-groups', name: 'Homeschool groups', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780825/Homeschool_groups_byih2a.svg" },
  { id: 'international-schools', name: 'International schools', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780829/International_schools_eakr5f.svg" },
  { id: 'library-programs', name: 'Library programs', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780832/Library_programs_oip7nf.svg" },
  { id: 'makerspace', name: 'Makerspace', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780833/Makerspace_bcosmr.svg" },
  { id: 'music-lessons', name: 'Music lessons', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780835/Music_lessons_c2olqe.svg" },
  { id: 'stem-lab', name: 'STEM Lab', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780854/STEM_Lab_w99zfa.svg" },
  { id: 'tutoring', name: 'Tutoring', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780858/Tutoring_kowkgn.svg" },
  { id: 'worldschool-meetups', name: 'Worldschool meetups', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780868/Worldschool_kedho6.svg" },

  { id: 'amusement-park', name: 'Amusement park', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780804/Amusement_park_qven9a.svg" },
  { id: 'aquarium', name: 'Aquarium', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780802/Aquarium_lz44rk.svg" },
  { id: 'art-gallery', name: 'Art gallery', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780802/Art_gallery_rhem4k.svg" },
  { id: 'childrens-museum', name: "Children's museum", icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780810/Children_s_museum_zw5cek.svg" },
  { id: 'farmers-market', name: "Farmer's market", icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780818/Farmer_s_market_bqvq4z.svg" },
  { id: 'hiking', name: 'Hiking', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780824/Hiking_g7zckg.svg" },
  { id: 'indoor-playground', name: 'Indoor playground', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780828/Indoor_playground_ldvqrx.svg" },
  { id: 'library', name: 'Library', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780832/Library_bwkbqc.svg" },
  { id: 'movie-theater', name: 'Movie theater', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780834/Movie_theater_vy5ylg.svg" },
  { id: 'museum', name: 'Museum', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780835/Museum_zltgsd.svg" },
  { id: 'national-park', name: 'National park', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780836/National_park_xdzwqf.svg" },
  { id: 'outdoor-playground', name: 'Outdoor playground', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780839/Outdoor_playground_qctsk5.svg" },
  { id: 'public-pool', name: 'Public pool', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780844/Public_pool_yggfoq.svg" },
  { id: 'rock-climbing', name: 'Rock climbing', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780846/Rock_climbing_bno1s3.svg" },
  { id: 'science-center', name: 'Science center', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780847/Science_center_b6z3vh.svg" },
  { id: 'skate-park', name: 'Skate park', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780850/Skate_park_ft4746.svg" },
  { id: 'skiing', name: 'Skiing', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780850/Skiing_qkyaki.svg" },
  { id: 'sport-course-fields', name: 'Sport course & fields', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780853/Sport_course_fields_hfbu72.svg" },
  { id: 'state-park', name: 'State park', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780854/State_park_xcjakz.svg" },
  { id: 'trampoline-park', name: 'Trampoline park', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780856/Trampoline_park_ha0kkx.svg" },
  { id: 'zoo', name: 'Zoo', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780864/Zoo_jwxtjn.svg" },

  { id: 'main_level_bathroom', name: 'Main level bathroom', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780833/Main_level_bathroom_pwb3wi.svg' },
  { id: 'main_level_bedroom', name: 'Main level bedroom', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780833/Main_level_bedroom_fkrsdw.svg' },
  { id: 'shower_chair', name: 'Shower chair', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780848/Shower_chair_i6supg.svg' },
  { id: 'single_level_home', name: 'Single level home', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780849/Single_level_home_cigvvc.svg' },
  { id: 'step_free_entrance', name: 'Step-free entrance', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780855/Step-free_entrance_nsqd2p.svg' },

  { id: 'baby_bath', name: 'Baby bath', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780801/Baby_bath_vrcra7.svg' },
  { id: 'bathtub', name: 'Bathtub', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780804/Bathtub_gweroi.svg' },
  { id: 'cleaning_products', name: 'Cleaning products', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780810/Cleaning_products_cjhzhe.svg' },
  { id: 'hair_dryer', name: 'Hair dryer', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780823/Hair_dryer_iukslc.svg' },
  { id: 'hot_water', name: 'Hot water', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780826/Hot_water_jcdgkc.svg' },
  {
    id: 'starter_toiletries',
    name: 'Starter toiletries',
    icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780853/Starter_toiletries_ltdstg.svg',
  },
  { id: 'towels', name: 'Towels', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780856/Towels_x8zp0y.svg' },

  { id: 'bed_linens', name: 'Bed linens', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780807/Bed_linens_lus1qk.svg' },
  { id: 'blackout_shades', name: 'Blackout shades', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780806/Blackout_shades_pcvwtz.svg' },
  { id: 'clothesline', name: 'Clothesline', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780811/Clothesline_esixjk.svg' },
  { id: 'clothing_storage', name: 'Clothing storage', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780812/Clothing_storage_m59rhh.svg' },
  { id: 'dryer', name: 'Dryer', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780816/Dryer_crbscx.svg' },
  { id: 'drying_rack', name: 'Drying rack', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780817/Drying_rack_rkyz74.svg' },
  { id: 'iron', name: 'Iron', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780829/Iron_suem5d.svg' },
  { id: 'king_bed', name: 'King bed', icon: null },
  { id: 'room_darkening_shades', name: 'Room-darkening shades', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780846/Room_darkening_shades_dxk4gz.svg' },
  {
    id: 'starter_essentials_bedroom',
    name: 'Starter essentials',
    icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780854/Starter_essentials_ajgixu.svg',
  },
  { id: 'steamer', name: 'Steamer', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780854/Steamer_dqvrbc.svg' },
  { id: 'washer', name: 'Washer', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780863/Washer_g2jjfy.svg' },

  { id: 'compost_bin', name: 'Compost bin', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780812/Compost_bin_zdwltj.svg' },
  { id: 'ev_charger', name: 'EV charger', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780817/EV_charger_dncslx.svg' },
  { id: 'solar_panels', name: 'Solar panels', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780852/Solar_panels_nj1mxw.svg' },

  { id: 'arcade_games', name: 'Arcade games', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780801/Arcade_games_ao7nrj.svg' },
  { id: 'books_and_reading_material', name: 'Books and reading material', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780808/Books_nf3ok7.svg' },
  {
    id: 'instruments',
    name: 'Instruments',
    icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780829/Instruments_nyjky1.svg',
  },
  { id: 'puzzles', name: 'Puzzles', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780844/Puzzles_kswidj.svg' },
  { id: 'record_player', name: 'Record player', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780844/Record_player_rnnde0.svg' },
  { id: 'smart_tv', name: 'Smart TV', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780852/Smart_TV_arfk0l.svg' },
  { id: 'sound_system', name: 'Sound system', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780852/Sound_system_nh3exo.svg' },
  { id: 'tv', name: 'TV', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780859/TV_zfoedk.svg' },

  { id: 'adult_bikes', name: 'Adult bikes', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780800/Adult_bike_aef70v.svg' },
  { id: 'baby_gates', name: 'Baby gates', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780801/Baby_gates_pdgxnf.svg' },
  { id: 'beach_toys', name: 'Beach toys', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780806/Beach_toys_iwsd2p.svg' },
  { id: 'board_games', name: 'Board games', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780801/Arcade_games_ao7nrj.svg' },
  {
    id: 'car_seat',
    name: 'Car seat',
    icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780809/Car_seat_pztaw1.svg',
  },
  { id: 'changing_table', name: 'Changing table', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780810/Changing_table_hp85j9.svg' },
  { id: 'crib', name: 'Crib', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780814/Crib_zme3ob.svg' },
  { id: 'kids_bikes', name: "Kid's bikes", icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780829/Kid_s_bikes_phhcse.svg' },
  {
    id: 'kids_books_and_toys',
    name: "Kid's books and toys",
    icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780830/Kid_s_toys_tmkpyh.svg',
  },
  { id: 'outlet_covers', name: 'Outlet covers', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780839/Outlet_covers_e7syxo.svg' },
  { id: 'pack_n_play', name: "Pack 'n play/travel crib", icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780858/Travel_crib_dkrym4.svg' },
  { id: 'stroller', name: 'Stroller', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780855/Stroller_yvvtks.svg' },

  { id: 'air_conditioning', name: 'Air conditioning', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780801/Air_conditioning_opncnt.svg' },
  { id: 'ceiling_fans', name: 'Ceiling fans', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780809/Ceiling_fans_o7teeb.svg' },
  { id: 'heating', name: 'Heating', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780823/Heating_dd4urz.svg' },
  { id: 'indoor_fireplace', name: 'Indoor fireplace', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780828/Indoor_fireplace_jo0ahg.svg' },
  { id: 'portable_fans', name: 'Portable fans', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780843/Portable_fans_t87ymh.svg' },

  { id: 'dedicated_workspace', name: 'Dedicated workspace', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780863/Workspace_pauvvt.svg' },
  { id: 'monitor', name: 'Monitor', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780834/Monitor_x5ydfy.svg' },
  { id: 'office', name: 'Office', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780838/Office_l86nwr.svg' },
  { id: 'printer_scanner', name: 'Printer/scanner', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780843/Printer_elpwsx.svg' },
  { id: 'wifi', name: 'Wifi', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780862/Wifi_gwrzjl.svg' },


  { id: 'basic_spices', name: 'Basic spices', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780804/Basic_spices_dypriv.svg' },
  { id: 'blender', name: 'Blender', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780807/Blender_hdlgok.svg' },
  { id: 'cleaning_products_kitchen', name: 'Cleaning products', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780810/Cleaning_kitchen_products_yd6rfa.svg' },
  { id: 'coffee_maker', name: 'Coffee maker', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780812/Coffee_maker_let0xy.svg' },
  {
    id: 'cooking_basics',
    name: 'Cooking basics',
    icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780813/Cooking_basics_du9dth.svg',
  },
  { id: 'dining_table', name: 'Dining table', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780814/Dining_table_l6vfd1.svg' },
  { id: 'dishes_and_silverware', name: 'Dishes and silverware', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780815/Dishes_z9wfw6.svg' },
  { id: 'dishwasher', name: 'Dishwasher', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780815/Dishwasher_qxgkrh.svg' },
  { id: 'freezer', name: 'Freezer', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780820/Freezer_jsrvqa.svg' },
  { id: 'high_chair', name: 'High chair', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780823/High_chair_tescmt.svg' },
  { id: 'hot_water_kettle', name: 'Hot water kettle', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780826/Hot_water_kettle_ckbpxa.svg' },
  { id: 'kids_dishes_and_utensils', name: "Kid's dishes and utensils", icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780830/Kid_s_dishes_y8xqyg.svg' },
  { id: 'kitchen', name: 'Kitchen', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780831/Kitchen_ddttnq.svg' },
  { id: 'microwave', name: 'Microwave', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780833/Microwave_gz8k9p.svg' },
  { id: 'oven', name: 'Oven', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780839/Oven_yvl6dd.svg' },
  { id: 'premium_coffee_maker', name: 'Premium coffee maker', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780843/Premium_coffee_maker_yidjz7.svg' },
  { id: 'refrigerator', name: 'Refrigerator', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780845/Refrigerator_buhcpv.svg' },
  {
    id: 'starter_essentials_kitchen',
    name: 'Starter essentials',
    icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780854/Starter_essentials_ajgixu.svg',
  },
  { id: 'stove', name: 'Stove', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780855/Stove_ycvyvf.svg' },
  { id: 'toaster', name: 'Toaster', icon: 'https://res-console.cloudinary.com/dwtmzqp2e/thumbnails/v1/image/upload/v1779780856/VG9hc3Rlcl92emduejA=/drilldown' },
  { id: 'tupperware', name: 'Tupperware', icon: 'https://res-console.cloudinary.com/dwtmzqp2e/thumbnails/v1/image/upload/v1779780858/VHVwcGVyd2FyZV90YnVybWQ=/drilldown' },
  { id: 'wine_glasses', name: 'Wine glasses', icon: 'https://res-console.cloudinary.com/dwtmzqp2e/thumbnails/v1/image/upload/v1779780863/V2luZV9nbGFzc2VzX3RzMndwcQ==/drilldown' },


  { id: 'backyard', name: 'Backyard', icon: 'https://res-console.cloudinary.com/dwtmzqp2e/thumbnails/v1/image/upload/v1779780803/QmFja3lhcmRfeW1hdWp3/drilldown' },
  { id: 'balcony', name: 'Balcony', icon: 'https://res-console.cloudinary.com/dwtmzqp2e/thumbnails/v1/image/upload/v1779780803/QmFsY29ueV9idGpoaHE=/drilldown' },
  { id: 'bbq', name: 'BBQ', icon: 'https://res-console.cloudinary.com/dwtmzqp2e/thumbnails/v1/image/upload/v1779780805/QkJRX3k1YXo5MA==/drilldown' },
  { id: 'driveway', name: 'Driveway', icon: 'https://res-console.cloudinary.com/dwtmzqp2e/thumbnails/v1/image/upload/v1779780816/RHJpdmV3YXlfdnBmbG5r/drilldown' },
  { id: 'fire_pit', name: 'Fire pit', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779862306/Firepit_zcjcpd.svg' },
  { id: 'free_parking', name: 'Free parking', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780820/Free_parking_twwito.svg' },
  { id: 'garage', name: 'Garage', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780821/Garage_wfgwet.svg' },
  { id: 'outdoor_dining_area', name: 'Outdoor dining area', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780838/Outdoor_dining_area_ct2bdb.svg' },
  { id: 'outdoor_furniture', name: 'Outdoor furniture', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780838/Outdoor_furniture_aizaoj.svg' },
  { id: 'outdoor_playground', name: 'Outdoor playground', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780839/Outdoor_playground_qctsk5.svg' },
  { id: 'patio', name: 'Patio', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780840/Patio_djne3i.svg' },

  { id: 'carbon_monoxide_detector', name: 'Carbon monoxide detector', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780809/Carbon_monoxide_detector_dal2b5.svg' },
  { id: 'exterior_cameras', name: 'Exterior cameras', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780817/Exterior_cameras_fid2fy.svg' },
  { id: 'fire_extinguisher', name: 'Fire extinguisher', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780819/Fire_extinguisher_caeyyx.svg' },
  { id: 'fire_ladder', name: 'Fire ladder', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780819/Fire_ladder_nwlvwz.svg' },
  { id: 'first_aid_kit', name: 'First-aid kit', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780819/First-aid_kit_b736fb.svg' },
  { id: 'humidifier_dehumidifier', name: 'Humidifier / Dehumidifier', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780827/Humidifier_gh82u8.svg' },
  { id: 'keypad', name: 'Keypad', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780829/Keypad_uil8xr.svg' },
  { id: 'pool_fence', name: 'Pool fence', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780842/Pool_fence_z4c4zi.svg' },
  { id: 'safe', name: 'Safe', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780846/Safe_b5kfth.svg' },
  { id: 'security_system', name: 'Security system', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780848/Security_system_yd3s6w.svg' },
  { id: 'smoke_detector', name: 'Smoke detector', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780851/Smoke_detector_wmu6ox.svg' },

  { id: 'beach_access', name: 'Beach access', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780806/Beach_access_ehfbrh.svg' },
  { id: 'car_access', name: 'Car access', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780808/Car_access_gdmezn.svg' },
  { id: 'elevator', name: 'Elevator', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780817/Elevator_uenlnf.svg' },
  {
    id: 'exercise_equipment',
    name: 'Exercise equipment',
    icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780817/Exercise_equipment_kbmo20.svg',
  },
  { id: 'fenced_yard', name: 'Fenced yard', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780818/Fenced_yard_rp9skh.svg' },
  { id: 'game_room', name: 'Game room', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780821/Game_room_bmtttf.svg' },
  { id: 'garden', name: 'Garden', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780821/Garden_rjtem7.svg' },
  { id: 'gated_community', name: 'Gated community', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780822/Gated_community_txeavn.svg' },
  { id: 'home_gym', name: 'Home gym', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780824/Home_gym_kkpceg.svg' },
  { id: 'home_theatre', name: 'Home theatre', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780825/Home_theatre_jr55v4.svg' },
  { id: 'hot_tub', name: 'Hot tub', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780826/Hot_tub_lnslxd.svg' },
  { id: 'housecleaning', name: 'Housecleaning (for additional fee)', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780827/Housecleaning_ebeax9.svg' },
  { id: 'ice_rink', name: 'Ice rink', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780827/Ice_rink_l8y8aw.svg' },
  { id: 'music_room', name: 'Music room', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780835/Music_room_pbaipk.svg' },
  { id: 'ocean_view', name: 'Ocean view', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780837/Ocean_view_kbot4y.svg' },
  { id: 'pets_allowed', name: 'Pets allowed', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780841/Pets_allowed_notxwn.svg' },
  { id: 'playroom', name: 'Playroom', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780841/Playroom_l6ij4j.svg' },
  { id: 'pool', name: 'Pool', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780842/Pool_cnzztx.svg' },
  { id: 'sauna', name: 'Sauna', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780846/Sauna_enmvls.svg' },
  { id: 'sun_room', name: 'Sun room', icon: 'https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780856/Sun_room_bt33aw.svg' },

  { id: 'no-parties', name: 'No parties', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780837/No_parties_pj27ap.svg" },
  { id: 'no-smoking', name: 'No smoking', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780837/No_smoking_wheher.svg" },

  { id: 'garden-care', name: 'Garden care', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780821/Garden_care_afyhv4.svg" },
  { id: 'houseplant-care', name: 'Houseplant care', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780827/Houseplant_care_kbu5cz.svg" },
  { id: 'lawn-care', name: 'Lawn care', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780831/Lawn_care_eof1jx.svg" },
  { id: 'mail-collection', name: 'Mail collection', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780833/Mail_collection_q6pz3r.svg" },
  { id: 'pet-sitting', name: 'Pet sitting', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780840/Pet_care_bouvyd.svg" },
  { id: 'pool-maintenance', name: 'Pool maintenance', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780842/Pool_maintenance_kpsyoj.svg" },
  { id: 'snow-removal', name: 'Snow removal', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780851/Snow_removal_mmigri.svg" },
  { id: 'trash-recycling', name: 'Trash & recycling', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780857/Trash_recycling_akbnyd.svg" },

  { id: 'homeschool-groups', name: 'Homeschool groups', icon: "https://res.cloudinary.com/dwtmzqp2e/image/upload/v1779780825/Homeschool_groups_byih2a.svg" },

]